import { createSlice } from '@reduxjs/toolkit';

import { initFailed, initSucceeded } from '../../actions/priceMatrixActions';

// `packageDataInitialized` is what lifts the loader, and both outcomes set it — a failure is still
// a finished initialisation.
const appStatusSlice = createSlice({
  name: 'appStatus',
  initialState: { packageDataInitialized: false, invalidInput: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (state) => {
        state.packageDataInitialized = true;
      })
      .addCase(initFailed, (state) => {
        state.invalidInput = true;
        state.packageDataInitialized = true;
      });
  },
});

export default appStatusSlice.reducer;
